.clamped {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--read-more-lines);
  line-clamp: var(--read-more-lines);
}
